type HelpCenterCreateProps = {
  className?: string;
};

export default function HelpCenterCreate({ className }: HelpCenterCreateProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M2.5 17.5V3.33337H18.3333V17.5H2.5ZM3.75 16.25H17.0833V4.58337H3.75V16.25ZM5.73729 14.2627H15.096V13.013H5.73729V14.2627ZM5.73729 11.0417H8.81417V6.57067H5.73729V11.0417ZM10.641 11.0417H15.096V9.79171H10.641V11.0417ZM10.641 7.82046H15.096V6.57067H10.641V7.82046Z"
        fill="currentColor"
      />
    </svg>
  );
}
